<!-- 上课类型 -->
<template>
  <el-form-item>
    <template #label>
      <slot>{{label}}</slot>
    </template>
    <el-select
      v-model="typeList"
      :multiple="config.multiple"
      :placeholder="placeholder"
      @clear="reset"
      :clearable="clearable"
    >
      <el-option v-for="item in chargeTypes" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-上课类型选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '上课类型：',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');

    const chargeTypes = ref([
      {
        id: 1,
        name: '正常上课',
      },
      {
        id: 2,
        name: '试听',
      },
      {
        id: 3,
        name: '临时',
      },
      {
        id: 4,
        name: '约课',
      },
      {
        id: 5,
        name: '补课',
      },
    ]);
    let typeList;
    function reset() {
      typeList.value = props.value;
    }

    typeList = useQuery('courseArrangeTypeList', props.value, reset);

    return {
      reset,
      chargeTypes,
      typeList,
    };
  },
};
</script>
